const membershipSubscriptionPaymentUpdateToast = (state = null, action) => {
  if (action.type === "SET_MEMBERSHIP_SUBSCRIPTION_PAYMENT_UPDATE_TOAST") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_MEMBERSHIP_SUBSCRIPTION_PAYMENT_UPDATE_TOAST": {
  //     return action.payload;
  //   }

  //   default: {
  //     return state;
  //   }
  // }
};

export default membershipSubscriptionPaymentUpdateToast;
